import React, {Component} from 'react';
import './newSubject.scss';
import $ from 'jquery';
import API from './../../config/api';
import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';
import Header from "../../components/Header/header";
import {Toast} from 'antd-mobile';
import AppBtn from "../../components/AppBtn/appBtn";
import TopBtn from "../../components/TopBtn/topBtn";
import DetailBtn from "../../components/DetailBtn/detailBtn";

const TYPE = {
	NEW: 'NEW'
}


@connect(
	state => ({admin: state.admin}),
	{refresh_admin}
)

class Subject extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {},
			uuid: '',
			type: TYPE.NEW,
			name: 'newSpecial',
			isPc: true
		};

	}

	componentWillMount() {
		$('html,body').css({
			'background-color': '#F4F4F4'
		})
		this.getContentId(this.props);
		this.getContent();
		this.statistics()
		// this.ymstatistics()
	}

	componentDidMount() {
		this.setVideoUrl()
		this._isPc()
	}
	componentWillReceiveProps(nextProps){
    if(this.props.match.params.uuid !== nextProps.match.params.uuid){
      $('html,body').css({
        'background-color': '#F4F4F4'
      })
      this.getContentId(nextProps);
      this.getContent();
      this.statistics()
      this.setVideoUrl()
    }
  }

	componentWillUnmount() {

	}
	//设置video的url
  setVideoUrl =()=>{
    const {data} = this.state
    data.list.forEach((item, index) => {
      if (item.module_type / 1 === 2) {
        this.initMap()
      } else if (item.module_type / 1 === 4) {
        let video_url = ''
        let video_cover = ''
        item.manuscript_list.forEach((liveItem, liveIndex) => {
          video_url = liveItem.row.ext_data.video_url
          video_cover = liveItem.row.cover
        })
        this.setState({haveLive: true,video_cover:video_cover},
          ()=>this.playVideo(video_url))
      }
    })
  }

	// shouldComponentUpdate() {
	//
	// }
	setDesc = (type) => {
		if (type === 1) {
			this.setState({descType: true})
		} else if (type === 2) {
			this.setState({descType: false})
		}
	}
	//换算分钟前
	changeBeforeTime = (beforetime, time) => {
		const date = new Date().getTime()
		const diffTime = date / 1000 - beforetime //毫秒
		let h = 0
    let m = 0
    let s = parseInt(diffTime,0)
		m = parseInt(s / 60,0)
		h = parseInt(m / 60,0)
		if (h >= 1) {
			if (h >= 48) {
				return time
			} else if (h >= 24 && h < 48) {
				return '1天前'
			} else {
				return h + '小时前'
			}
		} else {
			return m + '分钟前'
		}
	}
	//换算时分秒
	changeTime = (time) => {
		let h = 0, i = 0, s = parseInt(time,0)
		if (s > 60) {
			i = parseInt(s / 60,0)
			s = parseInt(s % 60,0)
		}
		if (i > 60) {
			h = parseInt(i / 60,0)
			i = parseInt(i % 60,0)
		}
		// 补零
		var zero = function (v) {
			return (v >> 0) < 10 ? "0" + v : v;
		}
		if (h === 0) {
			return [zero(i), zero(s)].join(':')
		} else {
			return [zero(h), zero(i), zero(s)].join(':')
		}
	}
	//跳转导航
	scrollDetail = (module_id) => {
		const id = '#' + module_id
		const div = $(id)[0]
		$('html,body').scrollTop(0).animate({scrollTop: $(div).offset().top}, 1000)
		return false;// 返回false可以避免在原链接后加上#
	}
	playVideo=(url)=> {
		this.refs.liveSource.src = url;
		this.refs.live.load();
		setTimeout(() => {
			this.refs.live.play();
		}, 1000)
	}

	//人物跳转链接
  jumpUrl = (url) =>{
	  if(url){
	    window.location.href = url
    }else {
	    return
    }
  }
  //判断是否是pc
  _isPc = () => {
    if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.setState({
        isPc: false
      })
    }
  }

	render() {
		const {data, uuid, name, haveLive, descType,video_cover,isPc} = this.state;

		return (
			<div className="newsubject-box">

				{/*头部*/}
				<Header name={name} uuid={uuid}/>

				{/*专题头部*/}
				{!haveLive ?
					<img className="newsubject-head-box"
               alt="头部图片"
               src={data.ext_data?data.ext_data.inner_cover:''}/> :
					<div className="subject-live-box">
						<video ref="live"
									 id="live"
									 playsInline="true"
									 webkit-playsinline="true"
									 x5-playsinline="true"
									 controls
                   preload="auto"
                   poster={video_cover}
									 loop>
							<source id="liveSource" ref="liveSource" src=""></source>
						</video>
					</div>
				}

				{/*描述*/}
				<div className={data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?"newsubject-desc lianghui-desc":'newsubject-desc'}>
					{data.desc.length >= 64 && !descType ? data.desc.substring(0, 63) : data.desc}
					{data.desc.length >= 64 && !descType ?
						<span onClick={this.setDesc.bind(this, 1)} className="descBtn">
              <span className="descIcon"></span>
              展开</span> :
            data.desc.length >= 64 ?
						<p onClick={this.setDesc.bind(this, 2)} className="descBtn">收起</p> : ''
					}
				</div>

				{/*专题导航*/}
				<ul className={data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ? "newsubject-menu lianghuiMenu" : 'newsubject-menu'}>
					{data.list.length > 0 ? data.list.map((item, index) => {
					  if(item.module_type/1 !== 4 && item.manuscript_list.length !== 0){
              return <li key={index}
                         className="menuBox"
                         onClick={this.scrollDetail.bind(this, item.module_id)}
              >{item.module_name}</li>
            }
					}) : ''}
				</ul>
        {data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?
        <div className="newsubject-banner"></div> : '' }

				{/*专题列表*/}
				<div className="new-subject-box">
					{/*专题题目*/}
					{/*<div className="newsubject-title">*/}
					{/*<div className="title" style={{*/}
					{/*overflow: 'hidden',*/}
					{/*textOverflow: 'ellipsis',*/}
					{/*display: '-webkit-box',*/}
					{/*'WebkitLineClamp': '2',*/}
					{/*'WebkitBoxOrient': 'vertical',*/}
					{/*}}>{data.desc}</div>*/}
					{/*</div>*/}
					{/*专题列表*/}
					<div className="newsubject-list">
						{
							data.list.map((item, index) => {
								if(item.manuscript_list.length === 0){
									return false
								}
								switch (parseInt(item.module_type)) {
									case 2:             //地点
										return (
											<div className="newsubject-position-box" id={item.module_id} key={index}>
												<div className="position-text">
                          <span className="red_line"></span>{item.module_name}
                          {data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?
                            <div className="right_icon"></div> : ''
                          }
												</div>
												<div className="positionItem">
													{/*地图*/}
													<div className="map">
														<div id="container"></div>
													</div>
												</div>
											</div>
										)
										break;
									case 3:             //人物
										return (
											<div className="newsubject-person-box" id={item.module_id} key={index}>
												<div className="person-text">
                          <span className="red_line"></span>{item.module_name}
                          {data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?
                          <div className="right_icon"></div> : '' }
                        </div>
												<div className="person-list">
													{/*新闻列表*/}
													{
														item.person_list.map((person_item, person_index) => {
															return (
																<div className="personItem" key={person_index} onClick={this.jumpUrl.bind(this,person_item.relate_url)}>
																	<div className="left" style={{
																		backgroundImage: 'url(' + person_item.head_image + ')'
																	}}></div>
																	<div className="right">
																		<div
																			className="name">{person_item.user_name}</div>
																		<div className="text" style={{
																			overflow: 'hidden',
																			textOverflow: 'ellipsis',
																			display: '-webkit-box',
																			'WebkitLineClamp': '2',
																			'WebkitBoxOrient': 'vertical',
																		}}>{person_item.keyword}</div>
																	</div>
																</div>
															)
														})
													}
												</div>
											</div>
										)
										break;
									case 5:   //普通稿件模块
									
										return (
											<div className="newsubject-normal-box" id={item.module_id} key={index}>
												<div className="normal-text">
                          <span className="red_line"></span>{item.module_name}
                          {data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?
                          <div className="right_icon"></div> : '' }
                        </div>
												<div className="normal-list">
													{(item.manuscript_list.length > 6 && !this.state.normalType ?
														item.manuscript_list.slice(0, 6) : item.manuscript_list).map((normal_item, normal_index) => {
														return <div className="newsubject-normal-item" key={normal_index}
																				onClick={this.goDetail.bind(this, normal_item)}>
															<DetailBtn normal_item={normal_item}
																				 changeTime={this.changeTime}
                                         goDetail={this.goDetail}
																				 changeBeforeTime={this.changeBeforeTime}></DetailBtn>
														</div>
													})}
												</div>
												{item.manuscript_list.length > 6 && !this.state.normalType ?
													<div className={data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?"viewMoreNormal lianghuiBg" : 'viewMoreNormal' } onClick={() => this.setState({normalType: true})}>查看更多
														></div> : ''}
											</div>
										)
										break;
									case 6:             //视频组
										return (
											<div className="newsubject-video-box" id={item.module_id} key={index}>
												<div className="video-text">
                          <span className="red_line"></span>{item.module_name}
                          {data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?
                          <div className="right_icon"></div> : '' }
                        </div>
												<div className="video-list">
													{/*视频列表*/}
													{(item.manuscript_list.length > 12 && !this.state.videoType ?
														item.manuscript_list.slice(0, 12) : item.manuscript_list).map((manu_item, manu_index) => {
														return (
															<div className="manuItem"
																	 onClick={this.goDetail.bind(this, manu_item)}
																	 key={manu_index}>
																<div className="manuCover">
																	<img alt="封面图" src={manu_item.row.cover}/>
																	<div className="manuTimeBox">
																		<span className="play-icon"></span>
																		<span>{this.changeTime(manu_item.row.ext_data.duration)}</span>
																	</div>
																</div>
																<div className="manuTitle line_2">{manu_item.row.title}</div>
															</div>
														)
													})
													}
												</div>
												{item.manuscript_list.length > 12 && !this.state.videoType ?
													<div className={data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ? "viewMoreVideo lianghuiBg" : "viewMoreVideo" }
                               onClick={() => this.setState({videoType: true})}>查看更多
														></div> : ''}
											</div>
										)
										break;
									case 7:             //时间
										return (
											<div className="newsubject-day-box" key={index} id={item.module_id}>
												{/*时间*/}
												<div className="newsubject-day-title">
													<span className="red_line"></span>{item.module_name}
                          {data.ext_data.tow_session&&data.ext_data.tow_session/1 === 1 ?
                          <div className="right_icon"></div> : '' }
                        </div>
												{/*时间线*/}
												{
													item.event_list.map((time_item, time_index) => {
														return (
															<div className="time_box" key={time_index}>
																<p className="time_title">{time_item.time}</p>
																<p className="time_content">{time_item.content}</p>
															</div>
														)
													})
												}
											</div>
                    )
					break;
					default:return ''
					break
								}
							})
						}
					</div>

					<TopBtn type={1}/>

				</div>

				{/*打开APP按钮*/}
				{isPc ? <AppBtn name={this.state.name} uuid={this.state.uuid} style={{marginTop: '.78rem'}}
								text="打开新京报App，阅读体验更佳"/> : ''}
				

			</div>
		);
	}

	ymstatistics() {
		setTimeout(() => {
			if (window._czc) {
				let location = window.location
				let contentUrl = location.pathname + location.hash
				let refererUrl = '/'
				window._czc.push(['_trackPageview', contentUrl], refererUrl)
			} else {
				console.log('_czc null')
			}
		}, 2000)
	}

	getContentId(props) {
		// console.log(this.props);
		const {uuid} = props.match.params;
		if (uuid) {
			this.state.uuid = uuid
		}
	}

	getContent() {
		$.ajax({
			type: 'get',
			url: API.special_detail,
			async: false,
			headers: {
				version: 'v201'
				// version: 'v104'
			},
			data: {
				uuid: this.state.uuid,
			},
			dataType: 'json'
		}).done((res) => {
			if (res.code == 0 || res.errorCode == 0) {
				this.setState({
					data: res.data
				})
				document.title = '专题 | ' + res.data.title;

				this.initWx({
					title: res.data.title,
					desc: res.data.desc,
				})
			} else {
				Toast.fail(res.msg || res.error);
			}
		});
	}

	initMap() {
		const {data} = this.state
		var latitude = -1;
		var longitude = -1;
		for (var i = 0; i < data.list.length; i++) {
			var temp = data.list[i];
			if (parseInt(temp.module_type) === 2) {
				latitude = parseFloat(temp.module_data.latitude)
				longitude = parseFloat(temp.module_data.longitude)
				break;
			}
		}
		if (latitude === -1) {
			return
		}

		var map = new window.AMap.Map('container', {
			center: [longitude, latitude],
			zoom: 11
		});

		// 创建 AMap.Icon 实例：
		var icon = new window.AMap.Icon({
			size: new window.AMap.Size(34, 39),    // 图标尺寸
			image: API.map_icon,  // Icon的图像
			// imageOffset: new window.AMap.Pixel(0, -60),  // 图像相对展示区域的偏移量，适于雪碧图等
			imageSize: new window.AMap.Size(34, 39)   // 根据所设置的大小拉伸或压缩图片
		});

		// 创建一个 Marker 实例：
		var marker = new window.AMap.Marker({
			position: new window.AMap.LngLat(longitude, latitude),
			// offset: new window.AMap.Pixel(-10, -10),
			icon: icon, // 添加 Icon 图标 URL
			title: '北京'
		});

		// 将创建的点标记添加到已有的地图实例：
		map.add(marker);
	}

	goDetail(item) {
		console.log(item)
		let _hostname = window.location.hostname;
		switch (parseInt(item.type)) {
			case 1:     //图文
				let jumpUrl1 = ``
				if (_hostname === 'cdn.bjnews.com.cn' || _hostname === '192.168.21.145') {  //正式环境
					if(!this.state.isPc){
						window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else {
						jumpUrl1 = `https://m.bjnews.com.cn/detail/${item.uuid}.html`
							window.location.href = jumpUrl1
					}
				
				} else {   //测试环境
					if(!this.state.isPc){
						window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else {
						this.props.history.push('/detail/1/' + item.uuid)
					}
				} 
				break;
			case 2:     //视频
				let jumpUrl2 = ``
				if (_hostname === 'cdn.bjnews.com.cn') {  //正式环境
					if(!this.state.isPc){
						window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					} else {
						jumpUrl2 = `https://m.bjnews.com.cn/detail/${item.uuid}.html`
						window.location.href = jumpUrl2
					}
				} else {   //测试环境
					if(!this.state.isPc){
						window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else {
						this.props.history.push('/detail/2/' + item.uuid + '/2')
					}		
				} 
				break;
			case 3:
			  if(item.row.special_type/1 ===1){
				  if(!this.state.isPc){
					window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
				  } else {
					this.props.history.push('/subject/1/' + item.uuid)
				  }
				}else if(item.row.special_type/1 ===2){
					if(!this.state.isPc){
						window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else{
						this.props.history.push('/subject/2/' + item.uuid)
					}
				}else if(item.row.special_type/1 ===3){
					if(!this.state.isPc){
						window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else {
						this.props.history.push('/newSubject/' + item.uuid)
					}
				}else if(item.row.special_type/1 ===4){
					if(!this.state.isPc){
						window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else {
						window.location.href = item.row.ext_data.article_url
					}
				}
				break;
			case 4:     //图说
				if(!this.state.isPc){
					window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
				}else {
					this.props.history.push('/detail/3/' + item.uuid)
				}
				break;
			case 6:     //直播
				if(!this.state.isPc){
					window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
				}else {
					this.props.history.push('/detail/2/' + item.uuid + '/6')
				}
				break;
			case 50:
					window.location.href = item.row.ext_data.article_url
				break;
			case 21:
				// const _hostname = window.location.hostname;
				let jumpUrl21 = `https://mtest.bjnews.com.cn/detail3?uuid=${item.uuid}`
				if (_hostname === 'cdn.bjnews.com.cn') {  //正式环境
					if(!this.state.isPc){
						jumpUrl21 = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else {
						jumpUrl21 = `https://m.bjnews.com.cn/detail3?uuid=${item.uuid}`
					}
				} else {   //测试环境
					if(!this.state.isPc){
						jumpUrl21 = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
					}else{
						jumpUrl21 = `https://mtest.bjnews.com.cn/detail3?uuid=${item.uuid}`
					}
				} 
				window.location.href = jumpUrl21
				break;
			default:''
		}
	}

	statistics(share) {
		var op = share ? 'share' : 'pv';
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = API.pv + '?xm=bjnews&wz=article_detail&op=' + op + '&pt=wap&unique_id=' + this.state.uuid;     //填自己的js路径
		$('body').append(script);
	}

	initWx(obj) {
		//分享
		var wxconfig = new window.WxConfig();
		wxconfig.init({
			appid: API.appid,
			url: window.location.href,
			title: obj.title,
			desc: obj.desc || API.share_des,
			link: window.location.href,
			imgUrl: API.share_img,
			successCallback: this.statistics.bind(this, true)
		});
	}

}

export default Subject;


// WEBPACK FOOTER //
// ./src/pages/NewSubject/newSubject.js